import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingGifToMp4ConverterConfig } from '@/data/landingConfig/landingGifToMp4ConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_GifToMp4Converter } from './schemaObject';

interface Props {}
const GifToMp4Converter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_GifToMp4Converter} />
			<VideoLandingTemplate
				data={landingGifToMp4ConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoConverter()}
			/>
		</>
	);
};

export default GifToMp4Converter;
